import { styled, Theme } from '@material-ui/core';

export const StyledPopover = styled('div')(({ theme }) => ({
  position: 'relative',
  color: 'black',
  borderRadius: 8,
}));

export type BubblePropsPositions = 'top' | 'left' | 'right' | 'bottom';

const viewportHeight = window.innerHeight;
const viewportWidth = window.innerWidth;

const getPosition = (position: BubblePropsPositions, rect: DOMRect) => {
  let newPosition = {};

  if (position === 'top') {
    newPosition = { ...newPosition, top: 30 };
  } else if (position === 'bottom') {
    newPosition = { ...newPosition, bottom: 30 };
  } else if (position === 'left') {
    newPosition = { ...newPosition, left: 30 };
  } else if (position === 'right') {
    newPosition = { ...newPosition, right: 35, top: 0 };
  }

  return newPosition;
};

const getAfterPosition = (position: BubblePropsPositions, rect: DOMRect) => {
  let newPosition = {};

  /*   top:
  position === 'top'
    ? '-10px'
    : position === 'right' || position === 'left'
    ? '20%'
    : undefined, */

  if (position === 'top' || position === 'bottom') {
    if (viewportWidth / 2 > rect?.left) {
      newPosition = { top: -10 };
    } else {
      newPosition = { top: -10 };
    }
  } else if (position === 'right' || position === 'left') {
    if (viewportHeight / 2 > rect?.top) {
      newPosition = { top: '20%' };
    } else {
      newPosition = { bottom: '20%' };
    }
  }

  return newPosition;
};

export const Bubble = styled('div')<Theme, { position: BubblePropsPositions; rect: DOMRect }>(
  ({ position, rect }) => ({
    '& > *': {
      textAlign: 'left',
    },
    position: 'absolute',
    background: '#ffffff',
    filter: 'drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.45))',
    textAlign: 'center',
    width: '250px',
    padding: 16,
    borderRadius: 8,
    zIndex: 1500,
    ...getPosition(position, rect),
    '&::after': {
      content: "''",
      position: 'absolute',
      display: 'block',
      width: '0',
      zIndex: 1,
      borderStyle: 'solid',
      borderColor:
        position === 'top' || position === 'bottom' ? '#ffffff transparent' : 'transparent #ffffff',
      borderWidth:
        position === 'top'
          ? '0 10px 10px'
          : position === 'bottom'
          ? '10px 10px 0'
          : position === 'left'
          ? '10px 10px 10px 0'
          : '10px 0 10px 10px',
      bottom: position === 'bottom' ? '-10px' : undefined,
      ...getAfterPosition(position, rect),
      left:
        position === 'left'
          ? '-10px'
          : position === 'top' || position === 'bottom'
          ? '20%'
          : undefined,
      right: position === 'right' ? '-10px' : undefined,
      marginLeft: position === 'bottom' || position === 'top' ? '-10px' : undefined,
      marginTop: position === 'left' || position === 'right' ? '-10px' : undefined,
    },
  })
);
